// /orgs/$orgSlug/admin/members (PRD §9.9, B6 PR3 / B6c).
//
// Route shell. Auth is enforced by __root.tsx; per-role gating
// (members blocked, admins / owners allowed) happens inside
// <AdminMembersPage> off the authStore membership shape that the
// useMe payload seeds at login.

import { createFileRoute, Link } from '@tanstack/react-router';

import { ApiError, apiErrorMessage } from '../api/client';
import { AdminMembersPage } from '../components/AdminMembersPage';

export const Route = createFileRoute('/orgs/$orgSlug/admin/members')({
  component: AdminMembersRoute,
  errorComponent: AdminMembersRouteError,
});

function AdminMembersRoute(): React.JSX.Element {
  const { orgSlug } = Route.useParams();
  return <AdminMembersPage orgSlug={orgSlug} />;
}

function AdminMembersRouteError({
  error,
}: {
  error: unknown;
}): React.JSX.Element {
  const isApi = error instanceof ApiError;
  const status = isApi ? error.status : null;
  const heading =
    status === 403
      ? 'You don’t have access to manage members'
      : status === 404
        ? 'Organization not found'
        : 'Something went wrong loading members';
  const body = apiErrorMessage(error, 'Try again, or return to the home page.');

  return (
    <div className="mx-auto max-w-2xl py-7">
      <p className="text-text-faint text-11 mb-2 uppercase tracking-wider">
        Error
      </p>
      <h1 className="text-text text-28 mb-3 font-semibold">{heading}</h1>
      <p className="text-text-muted mb-5 text-13">{body}</p>
      <Link
        to="/"
        className="bg-accent text-accent-fg border-border-strong rounded-2 hover:bg-accent-hi inline-block border px-3 py-2 text-13 transition-colors"
      >
        Back to home
      </Link>
    </div>
  );
}
